import dark from './dark';

const custom = (params) => dark(params, false);

export default custom;
